import React, { useState, useEffect } from 'react';
import { MY_PROFILE, UPDATE_INVOICES_SETTINGS } from '@api';
import { useQuery, useMutation } from "@apollo/client";
import { toast } from 'react-toastify';
import {
  FormGroup,
  Input,
  Label,
  Row,
  Col,
  Spinner,
  Container
} from 'reactstrap';

export default function InvoicesSettings(){
  const { data: profileData, loading } = useQuery(MY_PROFILE);
  const [canAgentsSendInvoices, setCanAgentsSendInvoices] = useState(true);

  useEffect(() => {
    if (profileData?.myProfile?.canAgentsSendInvoices !== undefined) {
      setCanAgentsSendInvoices(profileData.myProfile.canAgentsSendInvoices);
    }
  }, [profileData]);

  const [updateInvoicesSettings, { loading: updating }] = useMutation(UPDATE_INVOICES_SETTINGS, {
    onCompleted: (data) => {
      if (
        data.updateInvoicesSettings.errors &&
        data.updateInvoicesSettings.errors.length > 0
      ) {
        data.updateInvoicesSettings.errors.map((err) =>
          toast(err, { type: 'error' })
        );
      } else {
        toast(data.updateInvoicesSettings.message, { type: 'success' });
      }
    },
    onError: (e) => {
      console.log(e);
      toast(e.message, { type: 'error' });
    },
    refetchQueries: [MY_PROFILE],
  });

  if (loading) {
    return (
      <div className="text-center py-5">
        <Spinner color="primary" />
      </div>
    );
  }

  return(
    <>
      <Container className='p-4 d-flex align-items-center justify-content-center'>
        <Row className='pt-4'>
          <div className='w-100 mb-2 mb-md-0'>
            <Label className='mb-0' for='canAgentsSendInvoicesSwitch'>
              Do you want to allow your agents to send invoices on their own?
            </Label>
          </div>
          <div className='d-flex w-100'>
            <span className='mr-1'>No</span>
            <FormGroup check className="custom-control custom-switch m-0">
              <Input
                type="checkbox"
                className="custom-control-input"
                id="canAgentsSendInvoicesSwitch"
                checked={canAgentsSendInvoices}
                disabled={updating}
                onChange={(e) => {
                  const newValue = e.target.checked;
                  setCanAgentsSendInvoices(newValue);
                  updateInvoicesSettings({
                    variables: { canAgentsSendInvoices: newValue },
                  });
                }}
              />
              <Label className="custom-control-label" for="canAgentsSendInvoicesSwitch"></Label>
            </FormGroup>
            <span className=''>Yes</span>
          </div>
        </Row>
      </Container>
    </>
  )
}
